import { getContext } from 'svelte';
import type { Action } from 'svelte/action';
import type { ViewController } from './ViewController';
import { gsap } from 'gsap';

interface Options {
	delay: number;
	animation: {
		from: gsap.TweenVars;
		to: gsap.TweenVars;
	};
}

export const Slide = {
	from: {
		y: 28,
		opacity: 0
	},
	to: {
		duration: 1.8,
		delay: 0,
		y: 0,
		opacity: 1,
		ease: 'expo.out'
	}
};

const defaultAnimation = Slide;

export const EnterOnView: Action<HTMLElement, Partial<Options> | undefined> = (
	node: HTMLElement,
	options
) => {
	const params: Options = {
		delay: 0,
		animation: {
			...defaultAnimation,
			...options?.animation
		},
		...options
	};

	const controller: ViewController = getContext('view');
	if (!controller) {
		throw new Error('EnterOnView must be used within a ViewController');
	}
	let isEntered = false;

	if (controller.inView) return;
	gsap.set(node, {
		...params.animation.from
	});

	const enter = () => {
		if (isEntered) return;
		if (!controller.inView) {
			gsap.set(node, {
				...params.animation.from
			});
			return;
		}
		gsap.to(node, {
			...params.animation.to,
			delay: params.delay
		});
		isEntered = true;
	};

	controller.onUpdate.add(enter);

	return {
		destroy() {
			controller.onUpdate.remove(enter);
		}
	};
};
